import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOccurenceLocationChartsDataContext } from './hooks/useOccurenceLocationChartsDataContext';

export const ResidentialNeighborhood = () => {
    const { chartData } = useOccurenceLocationChartsDataContext();


    return (
        <SimpleBars
            title={'Bairro de Residência (Top 5)'}
            horizontal={true}
            subtitles={chartData?.residentialNeighborhood?.map((item) => item.description)}
            values={chartData?.residentialNeighborhood?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
